import { render } from "./CourseSidebar.vue?vue&type=template&id=73a0142e&scoped=true"
import script from "./CourseSidebar.vue?vue&type=script&lang=js"
export * from "./CourseSidebar.vue?vue&type=script&lang=js"

import "./CourseSidebar.vue?vue&type=style&index=0&id=73a0142e&lang=scss&scoped=true"

import exportComponent from "C:\\Server-Testumgebung\\way-academy-app-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a0142e"]])

export default __exports__